var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72667 9.00732L10.28 11.6607M10.2733 4.34065L5.72667 6.99398M14 3.33398C14 4.43855 13.1046 5.33398 12 5.33398C10.8954 5.33398 10 4.43855 10 3.33398C10 2.22941 10.8954 1.33398 12 1.33398C13.1046 1.33398 14 2.22941 14 3.33398ZM6 8.00065C6 9.10522 5.10457 10.0007 4 10.0007C2.89543 10.0007 2 9.10522 2 8.00065C2 6.89608 2.89543 6.00065 4 6.00065C5.10457 6.00065 6 6.89608 6 8.00065ZM14 12.6673C14 13.7719 13.1046 14.6673 12 14.6673C10.8954 14.6673 10 13.7719 10 12.6673C10 11.5627 10.8954 10.6673 12 10.6673C13.1046 10.6673 14 11.5627 14 12.6673Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.1bb7888577602414a1dd3f8330446fc2.svg";
export { ForwardRef as ReactComponent };